import { Controller } from "react-hook-form";
import { TimePicker } from "@onengine/component-library";
import type { ControlledFieldProps } from "./types";

export function ControlledTimePicker({
  name,
  control,
  error,
  clearErrors,
  placeholder,
}: ControlledFieldProps & { placeholder?: string }) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TimePicker
          value={field.value || ""}
          onChange={(v) => {
            field.onChange(v);
            clearErrors(name);
          }}
          placeholder={placeholder}
          error={error}
          clearable
        />
      )}
    />
  );
}
